import { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

const CohortAnalysis = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'cohortAggregatorAnalysis',
				path: mergePaths(PATHS.COHORT_ANALYSIS, PATHS.COHORT_AGGREGATOR_ANALYSIS)
			},
			{
				label: 'cohortIntegratorAnalysis',
				path: mergePaths(PATHS.COHORT_ANALYSIS, PATHS.COHORT_INTEGRATOR_ANALYSIS)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader title="cohortAnalysis" />
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default CohortAnalysis;
